<template>
  <div :class="$style.container">
    <img :class="$style.innate" src="@/assets/imgs/innate.png" />
    <innate-tooltip :hero="hero.name" position="bottom" />
  </div>
</template>

<script>
import InnateTooltip from '../tooltips/innate-tooltip.vue'

export default {
  name: 'hero-innate',
  components: { InnateTooltip },
  props: {
    hero: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" module>
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.innate {
  width: 2.6vw;
  height: 2.6vw;
}
</style>
